import Dialog from '../../../../dialogs/dialog';
import TableCaracteres from '../../../../../components/table-caracteres/table-caracteres';
import { GlobalProvider } from "../../../../../utils/globalprovider.js";

import React from 'react';
import './commontablecaracteres.css'
import { characters_getList } from '../../../../../utils/characters.js';

class CommonTableCaracteres extends Dialog {

  constructor(props) {
    super(props);

    const title = {
      fr: "Table des caractères",
      en: "Character table",
    };

    this.state.title = title;

    this.state.buttons =
      [
        { type: "back", disabled: false },
      ]
    
    this.onQuit = this.onQuit.bind(this);
    this.handleButton = this.handleButton.bind(this);
    this.onSubmitChar = this.onSubmitChar.bind(this);

    this.tableCaracteresRef = React.createRef();
    this.list = [];
  }

  
  componentDidMount() {
    super.componentDidMount();

    if (this.tableCaracteresRef && this.tableCaracteresRef.current) {
      this.list = characters_getList();
      this.tableCaracteresRef.current.setTableCaracteres(this.list);
    }
    
  }

  onQuit() {
    this.props.onButton({ name: "back" });
  }

  handleButton(buttonkey) {

    switch (buttonkey) {
      case 'back':        
        this.onQuit();
        break;
      
      default:
        return;
    }

  }

  async onSubmitChar(ch) {

    const hexToDecimal = (hex) => parseInt(hex, 16);
    const decimalValue = hexToDecimal(ch.unicode);
    const charString = String.fromCharCode(decimalValue) ?? ch.char;

    const subset = this.list.find((subset) =>
      subset.characters.some((character) => character.unicode === ch.unicode)
    );
      
    await navigator.clipboard.writeText(charString);

    this.props.onButton({ name: "char", value: charString, subset: subset?.name })
  }

  render() {
    var maxwidth = (window.innerWidth * 55) / 100;
    if (maxwidth > 800) maxwidth = 800;

    var maxheight = (window.innerHeight * 82) / 100;
    if (maxheight > 385) maxheight = 380;

    const retour =
      (
        <div style={{ width: maxwidth, height: maxheight }}>
          <div className="divcommontablecaracteres">
            <GlobalProvider>
              <TableCaracteres ref={this.tableCaracteresRef} onSubmitChar={this.onSubmitChar}></TableCaracteres>
            </GlobalProvider>
          </div>
        </div>
      )

    return super.render(retour);
  }
}

export default CommonTableCaracteres;